import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Atlanta Passport Agency — fastest route",
      "No long drive required",
      "Perfect for FedEx and St. Jude travel deadlines",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Atlanta Passport Agency access",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Must drive 3.5 hours to Nashville",
      "Full day commitment — difficult from Memphis",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function MemphisProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Memphis"
      introText="Memphis does not have its own regional passport agency. The closest is the Atlanta Passport Agency at 805 Broadway — about 3.5 hours east via I-40. For FedEx professionals with last-minute international meetings, St. Jude families with medical travel deadlines, and West Tennessee residents planning overseas vacations, that 3.5-hour drive each way is a full day commitment. Here is how your passport processing options compare, and why most Memphis and Shelby County travelers choose a registered courier instead."
      options={options}
      emergencyDescription="Memphis does not have a regional passport agency. The nearest facility is the Atlanta Passport Agency at 805 Broadway — approximately 210 miles east via I-40. For Memphis residents who secure an NPIC appointment (typically 2-3 weeks wait), the 3.5-hour drive each way means a full day lost. Even with an appointment, the agency only handles life-or-death emergencies on a same-day basis, and all documentation must be perfect. For any other urgent travel, Fast Passport Center's courier service delivers documents to Nashville without you ever leaving Shelby County."
      disclaimerText="*Processing speed depends on eligibility and documentation. Memphis does not have a regional passport agency — the closest is Nashville, approximately 210 miles away via I-40. Not all applicants qualify for Regional Agency Processing."
    />
  );
}